/** @typedef {'business_objectives'|'environmental'|'financial'|'health_and_safety'|'legal_regulatory_contractual'|'market_share'|'operational'|'reputational'} BiaCategoryKey */
/** @typedef {'NO_IMPACT'|'NEGLIGIBLE'|'MINOR'|'MODERATE'|'MAJOR'|'SEVERE'} BiaSeverityKey */
/** @typedef {'minutes'|'hours'|'days'|'weeks'} BiaTimeUnit */
/** @typedef {'SIMPLE_AVERAGE'|'WEIGHTED_AVERAGE'|'SINGLE_THRESHOLD'} BiaCalculationModel */

export const BIA_CATEGORY_POOL = [
    'business_objectives',
    'environmental',
    'financial',
    'health_and_safety',
    'legal_regulatory_contractual',
    'market_share',
    'operational',
    'reputational',
];

/** System default category keys (seed only — not a tenant whitelist). */
export const BIA_SYSTEM_CATEGORY_KEYS = BIA_CATEGORY_POOL;

export const BIA_SEVERITY_LEVELS = [
    { key: 'NO_IMPACT', score: 0, labelEn: 'No Impact', labelTr: 'Etki yok' },
    { key: 'NEGLIGIBLE', score: 1, labelEn: 'Negligible', labelTr: 'Önemsiz' },
    { key: 'MINOR', score: 2, labelEn: 'Minor', labelTr: 'Küçük' },
    { key: 'MODERATE', score: 3, labelEn: 'Moderate', labelTr: 'Orta' },
    { key: 'MAJOR', score: 4, labelEn: 'Major', labelTr: 'Büyük' },
    { key: 'SEVERE', score: 5, labelEn: 'Severe', labelTr: 'Ciddi' },
];

/** Severity keys eligible for per-category guidance text (scores 1–5). */
export const BIA_GUIDANCE_SEVERITY_KEYS = BIA_SEVERITY_LEVELS
    .filter((level) => level.score >= 1 && level.score <= 5)
    .map((level) => level.key);

export const BIA_TIME_UNITS = ['minutes', 'hours', 'days', 'weeks'];

export const BIA_CALCULATION_MODELS = [
    'SIMPLE_AVERAGE',
    'WEIGHTED_AVERAGE',
    'SINGLE_THRESHOLD',
];

export const SEVERITY_SCORE_BY_KEY = Object.fromEntries(
    BIA_SEVERITY_LEVELS.map((l) => [l.key, l.score]),
);

export const SEVERITY_KEY_BY_SCORE = Object.fromEntries(
    BIA_SEVERITY_LEVELS.map((l) => [l.score, l.key]),
);

export const SEVERITY_LABEL_EN_BY_KEY = Object.fromEntries(
    BIA_SEVERITY_LEVELS.map((l) => [l.key, l.labelEn]),
);
